export default __webpack_public_path__ + "static/berlin-mobile-fc22f9ed94b8db8fad25ebc698cedf79.png";